import axios, { AxiosResponse } from "axios";

import { VanProxySearchType } from "src/graphql/generated/globalTypes";

import { TokenData, VanObjectTypes, VanSearchFieldValue } from "./types";

export type SearchResponse<T extends VanProxySearchType> = {
  results: VanObjectTypes[T][];
  limit: number;
  offset: number;
  query: string | null;
  totalResultCount: {
    type: "exact" | "minimum";
    count: number;
  };
};

export function runSearch<SearchType extends VanProxySearchType>(
  token: TokenData,
  params: { [k: string]: any }
): Promise<AxiosResponse<SearchResponse<SearchType>>> {
  return axios.get(token.endpoint, {
    params: {
      token: token.token,
      ...params
    }
  });
}

export function getLabelAndIdForItem<SearchType extends VanProxySearchType>(
  searchType: SearchType,
  item: any
): VanSearchFieldValue {
  switch (searchType) {
    case VanProxySearchType.ACTIVIST_CODE:
      return {
        id: item.activistCodeId,
        label: item.name
      };
    case VanProxySearchType.SAVED_LIST:
      return {
        id: item.savedListId,
        label: item.name
      };
    case VanProxySearchType.SURVEY_QUESTION:
      return {
        id: item.surveyQuestionId,
        label: item.name
      };
    default:
      throw new Error("Invalid search type");
  }
}
